// src/components/common/NoSalonSelected.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStoreSlash } from "@fortawesome/free-solid-svg-icons";
import "./NoSalonSelected.css";

export default function NoSalonSelected() {
    const navigate = useNavigate();

    return (
        <div className="no-salon-container">
            <div className="icon-wrapper">
                <FontAwesomeIcon icon={faStoreSlash} size="4x" className="no-salon-icon" />
            </div>
            <h2 className="title">Salon Not Selected</h2>
            <p className="message">
                This page can only be accessed through a salon's booking link.
                Please contact your salon to get the correct link.
            </p>
            <button className="back-home-btn" onClick={() => navigate("/home")}>
                Go to Home
            </button>
        </div>
    );
}
